import { isFunction, isArray } from "lodash";
import BIModuleService from "../provider/BIModule/BIModuleService";
import { CHANGE_APP_PROPS, CHANGE_BI_MODEL_PROPS } from "./ActionConstants";

export function actionChangeBiModuleProps(props, callback) {
	return dispatch => {
		dispatch({ type: CHANGE_BI_MODEL_PROPS, props: props });
		if (isFunction(callback)) {
			setTimeout(callback, 500);
		}
	};
}

export function actionGetHomeStats(params, callback) {
	return dispatch => {
		dispatch({ type: CHANGE_APP_PROPS, props: { loading: true } });
		BIModuleService.getHomeStats(params)
			.then(response => {
				// truncate decimals
				if (isArray(response)) {
					for (let i in response) {
						response[i]["paid"] = parseInt(response[i]["paid"], 10);
						response[i]["data"]["A$"]["m"] = parseInt(
							response[i]["data"]["A$"]["m"],
							10
						);
						response[i]["data"]["A$"]["f"] = parseInt(
							response[i]["data"]["A$"]["f"],
							10
						);
						response[i]["data"]["NA$"]["m"] = parseInt(
							response[i]["data"]["NA$"]["m"],
							10
						);
						response[i]["data"]["NA$"]["f"] = parseInt(
							response[i]["data"]["NA$"]["f"],
							10
						);
					}
				}
				dispatch({ type: CHANGE_APP_PROPS, props: { loading: false } });
				dispatch({
					type: CHANGE_BI_MODEL_PROPS,
					props: { homeStats: response ? response : [] }
				});
				if (isFunction(callback)) {
					callback(response);
				}
			})
			.catch(error => {
				dispatch({ type: CHANGE_APP_PROPS, props: { loading: false } });
				if (isFunction(callback)) {
					callback(error);
				}
			});
	};
}

export function actionGetChildrenStats(params, callback) {
	return dispatch => {
		dispatch({ type: CHANGE_APP_PROPS, props: { loading: true } });
		BIModuleService.getChildrenStats(params)
			.then(response => {
				dispatch({ type: CHANGE_APP_PROPS, props: { loading: false } });
				dispatch({
					type: CHANGE_BI_MODEL_PROPS,
					props: { childrenStats: response ? response : [] }
				});
				if (isFunction(callback)) {
					callback(response);
				}
			})
			.catch(error => {
				dispatch({ type: CHANGE_APP_PROPS, props: { loading: false } });
				if (isFunction(callback)) {
					callback(error);
				}
			});
	};
}



// WEBPACK FOOTER //
// ./src/actions/BIModuleActions.js